/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PhotoType = {
    GAME_SCREENSHOT: 'GAME_SCREENSHOT',
    POLARIS_RZR_VERDANSK: 'POLARIS_RZR_VERDANSK',
    POLARIS_SPORTSMAN_REBIRTH: 'POLARIS_SPORTSMAN_REBIRTH',
    POLARIS_RZR_HAVENS_HOLLOW: 'POLARIS_RZR_HAVENS_HOLLOW',
    POLARIS_SPORTSMAN_HAVENS_HOLLOW: 'POLARIS_SPORTSMAN_HAVENS_HOLLOW',
    POLARIS_SPORTSMAN_VERDANSK: 'POLARIS_SPORTSMAN_VERDANSK',
    POLARIS_SPORTSMAN_AVALON: 'POLARIS_SPORTSMAN_AVALON',
    POLARIS_SPORTSMAN_FORTUNES_KEEP: 'POLARIS_SPORTSMAN_FORTUNES_KEEP'
} as const;
export type PhotoType = typeof PhotoType[keyof typeof PhotoType];


export function instanceOfPhotoType(value: any): boolean {
    for (const key in PhotoType) {
        if (Object.prototype.hasOwnProperty.call(PhotoType, key)) {
            if (PhotoType[key as keyof typeof PhotoType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PhotoTypeFromJSON(json: any): PhotoType {
    return PhotoTypeFromJSONTyped(json, false);
}

export function PhotoTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhotoType {
    return json as PhotoType;
}

export function PhotoTypeToJSON(value?: PhotoType | null): any {
    return value as any;
}

export function PhotoTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PhotoType {
    return value as PhotoType;
}

